import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { SupervisedBanner, SupervisedBannerContent, SupervisedStateText, SupervisedProgressBar, SupervisedProgressFill, } from '../../pages/AuctionHouse/AuctionDetail.styles';
const COUNTDOWN_DURATION = 30; // 30 seconds for going_once / going_twice
const stateLabels = {
    draft: 'Draft',
    accepting_bids: 'Accepting Bids',
    paused: 'Paused',
    going_once: 'GOING ONCE...',
    going_twice: 'GOING TWICE...',
    sold: 'SOLD!',
    closed: 'Closed',
};
const SupervisedStatusBar = ({ state }) => {
    const [countdown, setCountdown] = useState(COUNTDOWN_DURATION);
    const [startTime, setStartTime] = useState(null);
    const isCountdownState = state === 'going_once' || state === 'going_twice';
    // Reset countdown when state changes to a going state
    useEffect(() => {
        if (isCountdownState) {
            setStartTime(Date.now());
            setCountdown(COUNTDOWN_DURATION);
        }
        else {
            setStartTime(null);
            setCountdown(COUNTDOWN_DURATION);
        }
    }, [state, isCountdownState]);
    // Countdown ticker
    useEffect(() => {
        if (!isCountdownState || startTime === null)
            return;
        const interval = setInterval(() => {
            const elapsed = (Date.now() - startTime) / 1000;
            const remaining = Math.max(0, COUNTDOWN_DURATION - elapsed);
            setCountdown(remaining);
        }, 100); // Update every 100ms for smooth progress bar
        return () => clearInterval(interval);
    }, [isCountdownState, startTime]);
    if (!state || state === 'draft') {
        return null;
    }
    const progressPercent = isCountdownState
        ? (countdown / COUNTDOWN_DURATION) * 100
        : state === 'sold' || state === 'closed'
            ? 0
            : 100;
    return (_jsxs(SupervisedBanner, { "$state": state, children: [_jsxs(SupervisedBannerContent, { children: [_jsx(SupervisedStateText, { "$state": state, children: stateLabels[state] || state }), isCountdownState && (_jsxs("span", { style: {
                            fontSize: '14px',
                            fontWeight: 600,
                            color: 'var(--text-secondary)',
                            fontVariantNumeric: 'tabular-nums',
                        }, children: [Math.ceil(countdown), "s"] }))] }), isCountdownState && (_jsx(SupervisedProgressBar, { children: _jsx(SupervisedProgressFill, { "$percent": progressPercent, "$state": state }) }))] }));
};
export default SupervisedStatusBar;
